/**
 * StandardLayout
 * @module layouts/StandardLayout
 */

import React from 'react';
import { useAnchorLinkNavigation } from 'hooks';

import PageHeader from 'components/framework/PageHeader';
import PageFooter from 'components/framework/PageFooter';
import { SiteTypeContext } from 'context/siteType.context';
import clsx from 'clsx';

interface StandardLayoutProps {
	children?: any;

	header?: object;

	api?: object;

	footer?: object;

	modelType?: string;

	siteType?: string;
}

const StandardLayout: React.FC<StandardLayoutProps> = ({
	children,
	header,
	api,
	footer,
	modelType,
	siteType,
}) => {
	useAnchorLinkNavigation();
	return (
		<SiteTypeContext.Provider value={siteType}>
			<div
				className={siteType === 'LindabGroup' ? 'bg-lgLightGrayBlue' : 'white'}
			>
				<PageHeader
					header={header}
					api={api}
					includeHeading={modelType === 'StartPage'}
					modelType={modelType}
				/>
				{children}
				{footer && <PageFooter footer={footer} className={''} />}
			</div>
		</SiteTypeContext.Provider>
	);
};

export default StandardLayout;
